import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="silk-hero min-h-[70vh] flex items-center justify-center px-5">
      <div className="silk-card rounded-lg p-10 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <XCircle size={42} className="text-muted-foreground mx-auto mb-5" />
        <h1 className="font-display text-3xl text-foreground mb-2">Booking cancelled</h1>
        <p className="text-sm text-muted-foreground mb-8">No charge was made. Your time slot was released — you're welcome back anytime.</p>
        <Button asChild variant="outline" className="rounded-full px-8">
          <Link to="/browse">Back to explore</Link>
        </Button>
      </div>
    </div>
  );
}
